export const testimonials = [
  {
    name: 'Valeria Sosa',
    age: 34,
    role: 'Stretching & mobility coach',
    location: 'Córdoba, Argentina',
    initials: 'VS',
    headline: 'I stopped planning classes on Sunday nights.',
    quote:
      'I teach four group classes a week and used to spend hours deciding what to do next. Now I open the volume, find the week and I already have Class A, B and C ready. My students notice the classes connect from one week to the next.',
  },
  {
    name: 'Martín Aguirre',
    age: 41,
    role: 'Personal trainer',
    location: 'Rosario, Argentina',
    initials: 'MA',
    headline: 'Finally a clear path for Pike and Split work.',
    quote:
      'Most of my clients are strength-focused and I never had a structured way to add flexibility. The progressions from positioning to active control gave me a logical order. The Problem Solver bonus helps when someone compensates with the lower back.',
  },
  {
    name: 'Carolina Méndez',
    age: 29,
    role: 'Group fitness instructor',
    location: 'Mendoza, Argentina',
    initials: 'CM',
    headline: 'Mixed-level groups are much easier now.',
    quote:
      'In the same class I have beginners and students working toward a Middle Split. The "one goal, three levels" idea changed how I teach — everyone works the same area, each with the right variation.',
  },
  {
    name: 'Diego Fernández',
    age: 37,
    role: 'Mobility coach for runners',
    location: 'La Plata, Argentina',
    initials: 'DF',
    headline: 'The 30-minute versions save my schedule.',
    quote:
      'Some sessions I only have half an hour after a run. The Express Class Builder shows what to keep and what to cut without losing the purpose of the class. It feels professional and organized.',
  },
  {
    name: 'Luciana Romero',
    age: 46,
    role: 'Studio owner & flexibility instructor',
    location: 'Mar del Plata, Argentina',
    initials: 'LR',
    headline: 'My new instructors follow the same system.',
    quote:
      'I needed something my team could use consistently. With the 52 weeks organized and the level tracking sheets, every instructor knows where each group is and what comes next.',
  },
]
